import * as R from 'ramda'

export function format_to_readable(format) {
    return R.cond([
        [R.equals('A4_SINGLE'), R.always('A4 - Einzelproof')],
        [R.equals('A4_DERIVED'), R.always('A4 - Folgeproof')],
        [R.equals('A3_SINGLE'), R.always('A3 - Einzelproof')],
        [R.equals('A3_DERIVED'), R.always('A3 - Folgeproof')],
        [R.equals('A2_SINGLE'), R.always('A2 - Einzelproof')],
        [R.equals('A2_DERIVED'), R.always('A2 - Folgeproof')],
        [R.T, R.always('n/a')],
    ])(format)
}
